import { Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import {
  ShowMoreOnMobileState,
  ShowMoreOnMobileStateKeys,
  SHOW_MORE_ON_MOBILE_STATE_KEYS,
} from 'business/shift-report/report/pages/ReportView/types';
import { useMediaType } from 'technical/media/hooks';
import { ShowMoreToggle } from 'ui/show-more-button';
import { ShowMoreContainer } from 'ui/show-more-button/show-more-container';

import { MobileCardHeader } from './mobile-header';

type NoteContainerProps = {
  note?: string | null | undefined;
  showMore: ShowMoreOnMobileState;
  toggleShowMore: (key: ShowMoreOnMobileStateKeys) => () => void;
};

const { Paragraph } = Typography;

export const NoteContainer = ({
  note,
  showMore,
  toggleShowMore,
}: NoteContainerProps) => {
  const { isMobile } = useMediaType();
  const { t } = useTranslation();

  return (
    <Flex vertical className="bloc" key="tasks-note" gap={isMobile ? 8 : 0}>
      {isMobile ? (
        <MobileCardHeader>{t('pages.print.reportNote')}</MobileCardHeader>
      ) : (
        <h1>{t('pages.print.reportNote')}</h1>
      )}
      <ShowMoreContainer enableToggle={isMobile} toggleState={showMore.notes}>
        <Paragraph>{note || 'N/A'}</Paragraph>
      </ShowMoreContainer>
      <ShowMoreToggle
        enableToggle={isMobile}
        toggleState={showMore.notes}
        toggleFunc={toggleShowMore(SHOW_MORE_ON_MOBILE_STATE_KEYS.NOTES)}
      />
    </Flex>
  );
};
